//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../Features/Features.RegionListItemBuilderList.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"BodyOutput",1,0],[1,"BoundaryObject",0,"SelectTaggedObjectList",0],[0,"BridgeContinuity",1,0],[0,"OffsetDirection",1,0],[0,"OffsetSolid",1,0],[1,"ProjectionDirection",0,"GeometricUtilities.ProjectionOptions",0],[1,"RegionList",0,"Features.RegionListItemBuilderList",0],[1,"TargetFace",0,"ScCollector",0],[0,"Type",1,0]],[[[],"CreateRegionListItem",{R_:{regionListItemBuilder:"Features.RegionListItemBuilder"}},0,0],[["regionPoint","regionBoundaries"],"InsertPointBoundaryMap",{},2,0],[["regionPoint"],"ErasePointBoundaryMap",{},1,0],[["regionPoint","regionLaminarEdges"],"InsertPointLaminarMap",{},2,0],[["regionPoint"],"ErasePointLaminarMap",{},1,0]],[]];
SPLM.Features.VarOffsetFaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VarOffsetFaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VarOffsetFaceBuilder.Types = Object.freeze({
    "Panel" : "Panel", "Pad" : "Pad", "Network" : "Network"});

SPLM.Features.VarOffsetFaceBuilder.Continuity = Object.freeze({
    "Connected" : "Connected", "Tangent" : "Tangent"});

SPLM.Features.VarOffsetFaceBuilder.Output = Object.freeze({
    "OffsetasNewBody" : "OffsetasNewBody", "OffsetOriginalBody" : "OffsetOriginalBody"});

export default SPLM;